// Helpers para Google Analytics (GA4). gtag se carga en public/index.html.
// Nunca lanzan error: si gtag no está (bloqueadores, dev, etc.) no hacen nada.

export function trackEvent(nombre, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', nombre, params);
    }
  } catch { /* silencioso */ }
}

// Nombre legible de la página, para el informe por "tipo de página".
const NOMBRES_PAGINA = [
  ['/propiedad/', 'Ficha propiedad'],
  ['/corredor/', 'Perfil corredor'],
  ['/remate/', 'Ficha remate'],
  ['/remates', 'Remates'],
  ['/estadisticas/', 'Estadisticas propiedad'],
  ['/estadisticas', 'Estadisticas generales'],
  ['/nosotros', 'Quienes somos'],
  ['/vender', 'Vender'],
  ['/comprar', 'Comprar'],
  ['/alquileres', 'Alquileres'],
  ['/cancelar-busqueda', 'Cancelar busqueda'],
  ['/cancelar-remates', 'Cancelar remates'],
  ['/panel', 'Panel'],
  ['/login', 'Login'],
];

export function nombrePagina(pathname) {
  if (pathname === '/' || pathname === '') return 'Catalogo';
  const f = NOMBRES_PAGINA.find(([prefijo]) => pathname.startsWith(prefijo));
  return f ? f[1] : 'Otra';
}

// Ruta para GA sin datos sensibles (p. ej. ?token= de cancelación de búsquedas).
export function rutaSegura(pathname, search) {
  const params = new URLSearchParams(search || '');
  params.delete('token');
  const qs = params.toString();
  return pathname + (qs ? `?${qs}` : '');
}
